<section class="wagering-preferences-screen" data-cy="wagering-preferences-screen">
  <div class="sort-by tw-mb-[35px]">

    <!-- Sort By -->
    <p class="head tw-capitalize tw-text-[16px] tw-text-[#0F2950] tw-mb-[10px] tw-pt-[15px]" data-cy="pref-sort-txt">
      sort by
    </p>

    <!-- Name -->
    <div (click)="setPreference('name')" class="tw-flex tw-items-center" data-cy="pref-sort-name">
      <i
        [class.active]="sortBy === 'Name'"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-name-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-t
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        name
      </p>
    </div>

    <!-- MTP -->
    <div (click)="setPreference('mtp')" class="tw-flex tw-items-center" data-cy="pref-sort-mtp">
      <i
        [class.active]="sortBy === 'MTP'"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-mtp-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-uppercase
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        mtp
      </p>
    </div>
  </div>

  <!-- Wagering -->
  <div class="other-preference">

    <!-- Clean On Wager -->
    <div (click)="setPreference('clean-on-wager')" class="tw-flex tw-items-center" data-cy="pref-clear-wager">
      <i
        [class.active]="isClearWager"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-clear-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        clear on wager
      </p>
    </div>

    <!-- Require Confirmation -->
    <div (click)="setPreference('require-confirmation')" class="tw-flex tw-items-center" data-cy="pref-req-conf">
      <i
        [class.active]="requireConfirmation"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-req-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        require confirmation
      </p>
    </div>

    <!-- Keep Exotic Selections -->
    <div (click)="setPreference('keep-exotic-selections')" class="tw-flex tw-items-center" data-cy="pref-exotic-sel">
      <i
        [class.active]="isExoticSelections"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-exotic-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        keep exotic selections
      </p>
    </div>

    <!-- Display Thoroughbred -->
    <div (click)="setPreference('thoroughbred')" class="tw-flex tw-items-center" data-cy="pref-thoroughbred">
      <i
        [class.active]="isEventTypeExists('Thoroughbred')"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-thoroughbred-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        display thoroughbred
      </p>
    </div>

    <!-- Display Harness -->
    <div (click)="setPreference('harness')" class="tw-flex tw-items-center" data-cy="pref-harness">
      <i
        [class.active]="isEventTypeExists('Harness')"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-harness-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        display harness
      </p>
    </div>

    <!-- Display Greyhound -->
    <div (click)="setPreference('greyhound')" class="tw-flex tw-items-center" data-cy="pref-greyhound">
      <i
        [class.active]="isEventTypeExists('Greyhound')"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-greyhound-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        display greyhound
      </p>
    </div>

    <!-- Display International -->
    <div (click)="setPreference('international')" class="tw-flex tw-items-center" data-cy="pref-international">
      <i
        [class.active]="isEventTypeExists('International')"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-international-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold
          tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        display international
      </p>
    </div>

    <!-- Show Handicapper Icons -->
    <!-- <div (click)="setPreference('show-handicapper-icons')" class="tw-flex tw-items-center" data-cy="pref-handicapper">
      <i
        [class.active]="showHandicapperIcons"
        class="
          selector
          tw-block
          tw-w-[15px]
          tw-h-[15px]
          tw-bg-[#E8E8E8]
          tw-rounded-[10px]
          tw-border
          tw-border-[#E0E0E0]
          tw-mr-[9px]
        "
        data-cy="pref-handicapper-selector"
      ></i>
      <p
        class="
          tw-w-[94%]
          tw-capitalize
          tw-font-bold tw-text-[16px]
          tw-text-[#0F2950]
          tw-border-b
          tw-border-[#868484]
          tw-py-[2px]
          tw-pl-[7px]
        "
      >
        show handicapper icons
      </p>
    </div> -->

  </div>
</section>
